import { Component } from 'vue-property-decorator'
import { MemberActivities } from '@src/routes/members/member-activities'
import { MemberActivityFilters } from '@src/state/store'

@Component({
  computed: {
    activityFilters () {
      return this.$store.state.member_activities.memberActivityFilters
    }
  }
})
export class ReadonlyActivities extends MemberActivities {

  protected PAGE_SIZE = Math.floor((window.innerHeight - 140) / 105)

  protected activityFilters: MemberActivityFilters

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.ACTIVITIES')}`
  }
}
